import m from 'mithril'

import s from './styles.module.scss'

import SearchIcon from '@app/icons/search'
import IconBracket from '@app/icons/bracket-right'

import LoaderDotPulse from '@app/components/loader-dot-pulse'

import { scrollToElementIfNotInParentView } from '@app/helpers/utils'




const Datalist = {}

Datalist.oninit = vnode => {
    vnode.state.dropdown_displayed = vnode.attrs.show_df ?? false
    vnode.state.current_focus = vnode.attrs?.default_current_focus ?? 0
    vnode.state.input_value = vnode.attrs.defaultValue || ""

    vnode.state.setInputValue = val => {
        vnode.state.input_value = val;
    }

    vnode.state.clickOutsideListener = e => {
        if(!vnode.state.dropdown_displayed) return

        vnode.state.dropdown_displayed = false
        m.redraw()
    }

    window.addEventListener('click', vnode.state.clickOutsideListener)
}

Datalist.onremove = vnode => {
    window.removeEventListener('click', vnode.state.clickOutsideListener)
}

Datalist.view = vnode => {
    const {
        loading,
        has_options_as_buttons, // Temp hack for more flexible styling of options
    } = vnode.attrs

    const list = vnode.attrs.list || []
    const is_input_mode = vnode.attrs.is_input_mode ?? true
    const onsubmit = vnode.attrs.onsubmit
    const list_value = vnode.attrs.list_value
    const not_hide_when_select = vnode.attrs.not_hide_when_select
    
    if (!is_input_mode && list.length > 0) {
        const active_item_idx = list.findIndex(item => item.active)
        const active_item = list[active_item_idx] ?? list[0]

        vnode.state.input_value = active_item.name
        vnode.state.current_focus = active_item_idx
    }

    let classes = [s.input_wrapper]
    if(vnode.attrs.class){
        if(Array.isArray(vnode.attrs.class)) classes = classes.concat(vnode.attrs.class)
        else classes.push(vnode.attrs.class)
    }

    return m('div', {
        class: classes.join(' '),
        onclick: e => {
            e.stopPropagation()
            e.redraw = false
        }
    }, [
        is_input_mode && SearchIcon,
        is_input_mode ? [
            m('input', {
                oncreate: _vnode => {
                    if(vnode.attrs.focus) _vnode.dom.focus()
                },
                class: s.input,
                value: vnode.state.input_value,
                autocomplete:"off",
                role:"combobox",
                list:"",
                id: vnode.attrs.id,
                name: vnode.attrs.name,
                placeholder: vnode.attrs.placeholder,
                ariaLabel: vnode.attrs.ariaLabel,
                ariaExpanded: vnode.state.dropdown_displayed,
                ariaControls: 'datalist',
                onfocus: e => {
                    if(list.length > 0 && e.target.value.length > 0){
                        vnode.state.dropdown_displayed = true
                    }
                },
                oninput: e => {
                    const value = e.target.value
                    vnode.state.current_focus = vnode.attrs?.default_current_focus ?? 0
                    vnode.state.input_value = value
                    vnode.state.dropdown_displayed = value.length > 0
                    if(vnode.attrs.oninput) vnode.attrs.oninput(value)
                },
                onkeydown: e => {
                    if (onsubmit) {
                        onsubmit(e, vnode.state.input_value, () => {
                            vnode.state.current_focus = vnode.attrs?.default_current_focus ?? 0;
                        });
                        return;
                    }
                    if(e.keyCode == 40){
                        vnode.state.current_focus++
                        if(vnode.state.current_focus >= list.length) vnode.state.current_focus = 0
                        scrollToElementIfNotInParentView(list[vnode.state.current_focus]?.id, 'datalist');
                        return;
                    }
                    if(e.keyCode == 38){
                        vnode.state.current_focus--
                        if(vnode.state.current_focus < 0) vnode.state.current_focus = list.length - 1
                        scrollToElementIfNotInParentView(list[vnode.state.current_focus]?.id, 'datalist');
                    }
                    if(e.keyCode == 13){
                        e.preventDefault()
                        if(!vnode.state.input_value) {
                            return vnode.attrs.onselect(null, vnode.state.setInputValue);
                        }

                        if(is_input_mode && not_hide_when_select) {
                            const item = list[vnode.state.current_focus]
                            if(vnode.attrs.onselect) vnode.attrs.onselect(item, vnode.state.setInputValue)
                            vnode.state.dropdown_displayed = true;
                            const input = vnode.dom.getElementsByTagName('input')?.[0];
                            if(input) input?.focus();
                            return;
                        }
                        const item = list[vnode.state.current_focus]
                        vnode.state.input_value = item.name
                        if(vnode.attrs.onselect) vnode.attrs.onselect(item, vnode.state.setInputValue)
                        vnode.state.current_focus = 0
                        vnode.state.dropdown_displayed = false
                        return;
                    }
                },
            }),
            loading && m('div', {class: s.loading_bar}, m(LoaderDotPulse)),
        ]
        : m('button', {
            class: s.active_item_button,
            onclick: e => {
                vnode.state.dropdown_displayed = !vnode.state.dropdown_displayed
            },
        }, [
			m('span', {class: s.button_text}, vnode.state.input_value),
            m('span', {class: [s.dropdown_arrow, vnode.state.dropdown_displayed ? s.dropdown_arrow_active: ''].join(' ')}, IconBracket),
        ]),

        vnode.state.dropdown_displayed && list.length > 0 && m('datalist', {
            class: [s.datalist, vnode.attrs.datalist_class ?? ''].join(' '),
            id: 'datalist',
            role:"listbox",
        }, list.map((item, index) => {
            const option_classes = [s.option]
            if(vnode.state.current_focus === index) option_classes.push(s.active)

            if(list_value?.find(v=>v.id === item.id)) option_classes.push(...[s.checkmark])

            if (vnode.attrs.option_class) option_classes.push(vnode.attrs.option_class)

            return m((has_options_as_buttons) ? 'button' : 'option', {
                value: item.id,
                id: item?.id || null,
                class: option_classes.join(' '),
                onclick: e => {
                    e.preventDefault()
                    if(is_input_mode && not_hide_when_select) {
                        if(vnode.attrs.onselect) vnode.attrs.onselect(item, vnode.state.setInputValue)
                        vnode.state.current_focus = index;
                        vnode.state.dropdown_displayed = true;
                        const input = vnode.dom.getElementsByTagName('input')?.[0];
                        if(input) input?.focus();
                        return;
                    }

                    vnode.state.input_value = item.name
                    if(vnode.attrs.onselect) vnode.attrs.onselect(item, vnode.state.setInputValue)
                    vnode.state.current_focus = 0
                    vnode.state.dropdown_displayed = false
                },
            }, [
                // TEMP HACK:
                // If more flexible styling is required, provide a component AND set has_options_as_buttons as true
                // Technically, <option> are supposed to only have text content as children and also won't render as expected otherwise
                item.component || item.name
            ])
        })),
    ])
}

export default Datalist
